import React from "react";
import { useTranslation } from "react-i18next";
import MIcon from "../../icons/MIcon";
import CardHeader from "../ui/CardHeader";
import {
  formatInt,
  formatDateTime,
  formatDurationSeconds,
} from "../../utils/formatters";

/**
 * RecentCallsCard — table of the most recent calls.
 *
 * Props:
 *   rows: {
 *     id, created_at, org_name, caller_identity, trunk_number,
 *     duration_s, events_count, has_transcript,
 *   }[]
 */
const RecentCallsCard = ({ rows }) => {
  const { t } = useTranslation();
  return (
  <div className="flat-card rounded-xl">
    <div className="p-6 sm:p-8">
      <CardHeader
        icon="call_log"
        title={t("analytics.recentCalls.title")}
        subtitle={t("analytics.recentCalls.subtitle", { count: rows.length })}
      />
      {rows.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10 text-on-surface-light-variant dark:text-on-surface-variant">
          <MIcon name="inbox" className="!text-[32px] mb-2 opacity-60" />
          <p className="text-sm">{t("analytics.recentCalls.empty")}</p>
        </div>
      ) : (
        <div className="overflow-x-auto -mx-2">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-wider text-on-surface-light-variant dark:text-on-surface-variant border-b border-surface-light-highest dark:border-white/5">
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.when")}</th>
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.business")}</th>
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.caller")}</th>
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.trunk")}</th>
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.duration")}</th>
                <th className="px-3 py-2 font-medium">{t("analytics.recentCalls.events")}</th>
                {/* <th className="px-3 py-2 font-medium">Transcript</th>*/}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.id}
                  className="border-b border-surface-light-highest/60 dark:border-white/5 last:border-0 hover:bg-surface-light-container dark:hover:bg-surface-container transition-colors"
                >
                  <td className="px-3 py-3 text-on-surface-light-variant dark:text-on-surface-variant font-mono text-xs">
                    {formatDateTime(r.created_at)}
                  </td>
                  <td className="px-3 py-3 text-on-surface-light dark:text-on-surface font-medium">
                    {r.org_name ?? "—"}
                  </td>
                  <td className="px-3 py-3 text-on-surface-light-variant dark:text-on-surface-variant">
                    {r.caller_identity ?? "—"}
                  </td>
                  <td className="px-3 py-3 text-on-surface-light-variant dark:text-on-surface-variant font-mono text-xs">
                    {r.trunk_number ?? "—"}
                  </td>
                  <td className="px-3 py-3 text-on-surface-light-variant dark:text-on-surface-variant">
                    {formatDurationSeconds(r.duration_s)}
                  </td>
                  <td className="px-3 py-3 text-on-surface-light-variant dark:text-on-surface-variant">
                    {formatInt(r.events_count)}
                  </td>
                  {/* <td className="px-3 py-3">
                    {r.has_transcript ? (
                      <span className="inline-flex items-center gap-1 text-emerald-600 dark:text-emerald-400">
                        <MIcon name="description" className="sm" />
                      </span>
                    ) : (
                      <span className="text-on-surface-light-variant/60 dark:text-on-surface-variant/60">
                        —
                      </span>
                    )}
                  </td>*/}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
  );
};

export default RecentCallsCard;
